var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "renwu-customer" },
    [
      _c("div", { staticClass: "from-item" }, [
        _c("span", { staticClass: "from-lable" }, [_vm._v("客户姓名")]),
        _vm._v(" "),
        _c("div", { staticClass: "from-control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name",
              },
            ],
            attrs: { type: "text", placeholder: "请输入客户姓名" },
            domProps: { value: _vm.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "from-item" }, [
        _c("span", { staticClass: "from-lable" }, [_vm._v("客户手机号")]),
        _vm._v(" "),
        _c("div", { staticClass: "from-control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            attrs: { type: "text", placeholder: "请输入客户手机号" },
            domProps: { value: _vm.phone },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "add_phone", on: { click: _vm.addPhone } }, [
        _c("img", { attrs: { src: require("../../images/add.png") } }),
        _vm._v(" 添加手机号\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.phoneList, function (phoneItem, index) {
        return _c("div", { staticClass: "from-item" }, [
          _c("span", { staticClass: "from-lable" }, [
            _vm._v("客户手机号" + _vm._s(index + 1) + " "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "from-control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: phoneItem.phone,
                  expression: "phoneItem.phone",
                },
              ],
              attrs: { type: "text", placeholder: "请输入客户手机号" },
              domProps: { value: phoneItem.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(phoneItem, "phone", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "from-after",
              on: {
                click: function ($event) {
                  return _vm.deletePhone(phoneItem, index)
                },
              },
            },
            [_vm._v("删除")]
          ),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "from-item" }, [
        _c("span", { staticClass: "from-lable" }, [_vm._v("客户性别")]),
        _vm._v(" "),
        _c("div", { staticClass: "from-control" }, [
          _c(
            "div",
            { staticClass: "radio-group" },
            _vm._l(_vm.sexList, function (item) {
              return _c(
                "span",
                {
                  key: item,
                  class: ["radio", item == _vm.sex ? "selected" : ""],
                  on: {
                    click: function ($event) {
                      _vm.sex = item
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-commit", on: { click: _vm.commit } }, [
        _vm._v("保存"),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }